import { createAsyncActionType } from './index';

export const REMOTE_CLASSROOM_CONTENT_GET = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_CONTENT_GET');

export const REMOTE_CLASSROOM_COMMENTS_GET = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_COMMENTS_GET');

export const REMOTE_CLASSROOM_COMMENTS_SET = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_COMMENTS_SET');

export const REMOTE_CLASSROOM_LIKE_DISLIKE = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_LIKE_DISLIKE');